import DatabaseService from './database';
import TraditionalPdfGenerator from './traditionalPdfGenerator';

class PedigreeExporter {
  static async exportToPDF(bird, commonAncestors = [], duplicateColors = new Map(), options = {}) {
    try {
      // Get user settings for PDF generation
      const settings = await DatabaseService.getSettings();
      
      // Use traditional PDF generator that matches classic pedigree style
      const pdfGenerator = new TraditionalPdfGenerator();
      return await pdfGenerator.exportToFile(bird, commonAncestors, {
        loftName: settings.loftName || 'YOUR LOFT NAME',
        loftSlogan: settings.loftSlogan || '',
        loftPhone: settings.loftPhone || '',
        loftEmail: settings.loftEmail || '',
        breederName: settings.breederName || '',
        ...settings,
        duplicateColors // Pass the color mapping to the PDF generator
      }, options);

    } catch (error) {
      console.error('Error exporting PDF:', error);
      throw error;
    }
  }

  static async createPreview(bird, commonAncestors = [], duplicateColors = new Map()) {
    return this.exportToPDF(bird, commonAncestors, duplicateColors, { download: false });
  }

  static async createPreviewForBirdId(birdId) {
    const bird = await DatabaseService.getBirdById(birdId);
    if (!bird) throw new Error('Bird is no longer available');
    const { allDuplicateIds, duplicates } = await DatabaseService.findCommonAncestors(birdId);
    return this.createPreview(bird, allDuplicateIds, duplicates);
  }
}

export default PedigreeExporter;
